export interface ChartPageData {}

export interface ChartPageProps extends ChartPageData {}
